import React from 'react';
import { string, number } from 'prop-types';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import css from './LastMinuteBadge.module.css';

const LastMinuteBadge = (props) => {
  const { className, hours } = props;
  const classes = classNames(css.root, className);

  return (
    <span className={classes}>
      <FormattedMessage id="ListingCard.notBookableLastMinute" values={{ hours }} />
    </span>
  );
};

LastMinuteBadge.defaultProps = {
  className: null,
};

LastMinuteBadge.propTypes = {
  className: string,
  hours: number.isRequired,
  intl: intlShape, // injected but not used directly
};

export default injectIntl(LastMinuteBadge);
